var map = {
	"./bridge_positive/translations/es/translation.json": 3003,
	"./criptokuantica/translations/es/translation.json": 3497,
	"./domum/translations/es/translation.json": 2848,
	"./impozo/translations/es/translation.json": 2042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1121;